import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 1000,
    position: 'absolute',
    top: '8px',
    left: '32px',
    right: '32px'
  }
}))

export default useStyles
